export default "__VITE_ASSET__X4k58D5m__"